exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .price-display.inline {\n  display: inline;\n}\n\n.pc .price-display.inline .price {\n  font-size: 14px;\n  display: inline;\n  margin-right: 4.66667px;\n}\n\n.pc .price-display.inline .code {\n  display: inline;\n  font-size: 11px;\n}\n\n.pc .price-display .price {\n  font-size: 17px;\n}\n\n.pc .price-display .code {\n  color: #999999;\n}\n\n", ""]);

// exports
